import { Stack } from '@mui/material';
import React from 'react';
import { useTranslation } from '../../../hooks/useTranslation';
import StyledCTAButton from '../Button/StyledCTAButton';
import Text from '../Text/Text';

interface AgentCreationSuccessActionsProps {
  congratsMessage: string;
  onGoToAgents: () => void;
  /** When true, shows the embed Done button (call-agent success only). */
  showDone?: boolean;
  onDone?: () => void;
  /** When true, shows Choose A Plan (free / no paid plan). Hidden for enterprise. */
  showChooseAPlan?: boolean;
  onChooseAPlan?: () => void;
}

// The "Congratulations" heading, message, and CTA button row shared by
// AgentForm's and ChatAgentForm's post-creation success screens. Each
// caller keeps its own surrounding layout (they differ — see
// docs/specs on why call/chat success pages aren't otherwise identical).
const AgentCreationSuccessActions: React.FC<
  AgentCreationSuccessActionsProps
> = ({
  congratsMessage,
  onGoToAgents,
  showDone = false,
  onDone,
  showChooseAPlan = false,
  onChooseAPlan,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Text type="h2">{t('Congratulations 🎉')}</Text>
      <Text type="subtitle2">{congratsMessage}</Text>
      <Stack direction="row" gap="1rem" flexWrap="wrap" justifyContent="center">
        <StyledCTAButton
          size="large"
          onClick={onGoToAgents}
          width="fit-content"
        >
          {t('Go To Agents')}
        </StyledCTAButton>
        {showDone && onDone && (
          <StyledCTAButton size="large" onClick={onDone} width="fit-content">
            {t('Done')}
          </StyledCTAButton>
        )}
        {showChooseAPlan && onChooseAPlan && (
          <StyledCTAButton
            size="large"
            onClick={onChooseAPlan}
            color="success"
            width="fit-content"
          >
            {t('Choose A Plan')}
          </StyledCTAButton>
        )}
      </Stack>
    </>
  );
};

export default AgentCreationSuccessActions;
